/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーアイコンリスト ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const FullvideoPlayerIconlist = (props) => {
    /**
     * アイコン上に出す吹き出し位置の調整
     * @param e イベント
     */
    const fnOnMouseEnterIcon = (e) => {
        const balloon = e.target.closest("li").querySelector("div");
        const leftBalloon = balloon.getBoundingClientRect().left;
        const rightBalloon = balloon.getBoundingClientRect().right;
        const player = props.refFullvideoPlayerContainer.current;
        const leftPlayer = player.getBoundingClientRect().left;
        const rightPlayer = player.getBoundingClientRect().right;
        if (leftBalloon < leftPlayer + 6) {
            // FullvideoPlayerの左端 + 6pxより吹き出し位置が左にならない
            balloon.style.marginLeft = leftPlayer + 6 - leftBalloon + "px";
        } else if (rightPlayer - 6 < rightBalloon) {
            // FullvideoPlayerの右端 + 6pxより吹き出し位置が右にならない
            balloon.style.marginLeft = rightPlayer - 6 - rightBalloon + "px";
        }
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnMouseEnterIcon={fnOnMouseEnterIcon} />;
};
